export default __webpack_public_path__ + "static/media/etape1_search.7a30d031.webp";